(ns practitest.frontend.common.fetch
  (:require
    [practitest.frontend.common.dom :as dom]))

(defn- pt-fetch
  "Internal helper. js/fetch with session-auth defaults (CSRF, credentials, JSON headers).

  Parameters:
    - `url`: URL.
    - `opts`: Options map with following keys:
      - `:method`: HTTP verb (default \"GET\").
      - `:body`: Clojure map that gets JSON-stringified. Omit for GET.

  Returns promise."
  [url {:keys [method body] :or {method "GET"}}]
  (let [opts (cond-> {:method method
                      :headers {"X-CSRF-Token" (dom/csrf-token)
                                "Content-Type" "application/json"
                                "Accept" "application/json"}
                      :credentials "include"}
               body (assoc :body (js/JSON.stringify (clj->js body))))]
    (js/fetch url (clj->js opts))))

(defn fetch-json
  "Session-authenticated fetch that parses response body as keywordized JSON.
  Tolerates empty bodies (returns :body nil for those).

  See `pt-fetch` for the `opts` shape.

  Returns a promise of {:status :ok? :body}."
  [url opts]
  (-> (pt-fetch url opts)
      (.then (fn [resp]
               (-> (.text resp)
                   (.then (fn [text]
                            {:status (.-status resp)
                             :ok? (.-ok resp)
                             :body (when (seq text)
                                     (js->clj (js/JSON.parse text) 
                                              :keywordize-keys true))})))))))

(defn fetch-text
  "Session-authenticated fetch that returns response body as a raw string.
  Tolerates empty bodies (returns :body nil for those).
  Useful when the caller will re-emit the body verbatim -
  e.g. relaying a JSON response as an LLM tool result without parsing.

  See `pt-fetch` for the `opts` shape.

  Returns a promise of {:status :ok? :body}."
  [url opts]
  (-> (pt-fetch url opts)
      (.then (fn [resp]
               (-> (.text resp)
                   (.then (fn [text]
                            {:status (.-status resp)
                             :ok? (.-ok resp)
                             :body (when (seq text) text)})))))))
